export const getDeployPageType = (pathname: string) => {
    if (pathname === '/') {
        return 'HOME_PAGE';
    } else if (pathname.startsWith('/series')) {
        return 'SERIES_PAGE';
    }
    return '';
};
